import apiClient, { extractData } from '../api-client';

// Trang Tích hợp bên thứ 3 (chỉ super_admin). Khoá gọi vào chỉ có bản gốc ở
// response của addKey (một lần); khoá gọi ra chỉ có bản gốc ở revealKey.
export const integrationApi = {
  list() {
    return apiClient.get('/integrations').then(extractData);
  },
  addKey(key, body) {
    return apiClient.post(`/integrations/${key}/keys`, body).then(extractData);
  },
  revokeKey(key, id) {
    return apiClient.delete(`/integrations/${key}/keys/${id}`).then(extractData);
  },
  revealKey(key, id, password) {
    return apiClient.post(`/integrations/${key}/keys/${id}/reveal`, { password }).then(extractData);
  },
  saveHrmUrl(url) {
    return apiClient.put('/integrations/hrm_webhook/url', { url }).then(extractData);
  },
  requeueHrmBadSignature() {
    return apiClient.post('/integrations/hrm_webhook/requeue-401').then(extractData);
  },
};
